export default "  <div class=\"col_izquierda\">\n    <div class=\"banner\">\n      <img src=\"assets/img/banners.jpg\" />\n    </div>\n  </div>\n"